<template>
  <div>
    <div class="text-xs-center mb-3 hidden-xs-only">
      <v-btn 
        icon
        class="primary"
        @click="movePrevWeek()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      {{ year }} {{ $t('page.matches.week') }} [ {{ week }} ]  <small>{{ weekDates.firstDay }} <v-icon>code</v-icon> {{ weekDates.lastDay }}</small>
      <v-btn 
        icon
        class="primary"
        @click="moveNextWeek()">
        <v-icon>arrow_forward</v-icon>
      </v-btn>
    </div>
    <div class="text-xs-center mb-3 hidden-sm-and-up">
      <div>{{ year }} {{ $t('page.matches.week') }} [ {{ week }} ]</div>
      <div><small>{{ weekDates.firstDay }} <v-icon>code</v-icon> {{ weekDates.lastDay }}</small></div>
      <div>
        <v-btn 
          icon
          class="primary"
          @click="movePrevWeek()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-btn 
          icon
          class="primary"
          @click="moveNextWeek()">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
// const debug = require('debug')('OD::WeekNavigation')

export default {
  name: 'WeekNavigation',
  props: {
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
    weekDates: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    moveNextWeek() {
      this.$emit('moveNextWeek')
    },
    movePrevWeek() {
      this.$emit('movePrevWeek')
    },
  },
}
</script>

<style>
</style>
